module.exports = __webpack_public_path__ + "static/media/appointment-icon.4f63ea5f.svg";